import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import ReactPlayer from '../../../../components/ReactPlayer';

import '../style.scss';

const ParagraphVideo = ({ entity }) => {
  const remoteVideo = entity.getIn(['field_video_media', 0, 'source'], entity.getIn(['field_video_media', 0, 'embed']));
  const autoplay = entity.getIn(['field_video_autoplay', 0, 'value'], '');
  const controls = entity.getIn(['field_video_controls', 0, 'value'], '');
  const loop = entity.getIn(['field_video_loop', 0, 'value'], '');
  const poster = entity.getIn(['field_poster', 0, 'styles', 'paragraph_image']);
  const variant = entity.getIn(['field_variant', 0, 'value'], '');
  const caption = entity.getIn(['field_caption', 0, 'value'], '');

  return (
    <div className={`Paragraph color-${variant} ParagraphVideo`}>
      <Container>
        <div className="row">
          <div className="col-12">
            {remoteVideo && (
              <div className="ParagraphVideo__Wrapper">
                <ReactPlayer
                  url={remoteVideo}
                  width="100%"
                  height="100%"
                  className="ParagraphVideo__video"
                  loop={loop}
                  controls={controls}
                  light={poster}
                  playing={autoplay}
                  playIcon={<span className="ParagraphVideo__video__poster icon icon-play icon-variant-2" />}
                />
              </div>
            )}
            {caption && <span className="ParagraphVideo__caption">{caption}</span>}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphVideo;
